<template>
  <div>
    <ul class="tabbar">
      <li v-for="tabbar in tabbar" :key="tabbar.name">
        <div class="tabli" @click="tabClick(tabbar.path)">
          <img :src="tabbar.path== $route.path?tabbar.activeImg:tabbar.img" alt="">
          <div class="tabtext cbf font24" :class="{'active':tabbar.path== $route.path}">{{tabbar.name}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default{

  data () {
    return {
      tabbar: [
        {
          path: '/',
          img: require('../../static/image/home.png'),
          activeImg: require('../../static/image/home-active.png'),
          name: '抢单'
        },
        {
          path: '/service',
          img: require('../../static/image/service.png'),
          activeImg: require('../../static/image/service-active.png'),
          name: '进行中'
        },
        {
          path: '/query',
          img: require('../../static/image/query.png'),
          activeImg: require('../../static/image/query-active.png'),
          name: '历史'
        },
        {
          path: '/my',
          img: require('../../static/image/my.png'),
          activeImg: require('../../static/image/my-active.png'),
          name: '我的'
        }

      ]
    }
  },

  methods: {
    tabClick: function (path) {
      this.$router.push({path: path}).catch((res) => { console.log(res) })
    }
  }
}
</script>

<style>
  .tabbar{width: 7.5rem;height: 0.98rem;background: #fff;display: flex;align-items: center;;justify-content: space-between;box-shadow:0px -2px 4px rgba(0,0,0,0.05);position: fixed;bottom: 0;left: 0;right: 0;margin: auto;}
  .tabbar li{width: 25%;height: 100%;display: flex;align-items: center;justify-content: center;}
  .tabli{width: 0.8rem;height: 100%;box-sizing: border-box;padding-top: 0.1rem;}
  .tabli img{width: 0.48rem;height: 0.48rem;display: block;margin: 0 auto;}
  .tabtext{text-align: center;}
  .active{color: #333;}
</style>



// WEBPACK FOOTER //
// src/components/tabbar.vue